module.exports = __webpack_public_path__ + "img/030-spider.5ec2b129.png";